<template>
    <div class="content-wrapper">
      <div style="margin-top:-50px;padding:5px 5px;">
        <h3 style="float:left;">打印预览</h3>
        <el-button type="normal" size="small" class="but" @click="cancel()" style="float:right;">取消</el-button>
        <el-button type="primary" size="small" class="but" @click="print()" :disabled="loading" style="float:right;margin-right:10px;">立即打印</el-button>
        <div class="clearfix" />
      </div>
      <div style="border-width: 4px 0px 0;border-style: solid solid none;border-color: #e7eaec;"/>
      <div id="popup">
        <div v-for="item in itemList" style="page-break-after: always;">
          <p class="report_tit" style="font-size:26px;font-weight: bold;text-align: center;margin: 10px 0;">{{item.popupList.hospital}}儿童体检报告单</p>
          <span style="display: block;text-align: right;padding: 10px;border-bottom: 4px solid #333;">体检日期：{{item.popupList.checkDate}}</span>
          <p style="padding: 10px 0 10px 30px;margin: 0;"><span v-if="item.popupList.gardenName">{{item.popupList.gardenName}}，</span>{{item.popupList.childName}}的家长，您的孩子本次体检结果如下：</p>
          <!--<p class="checktype">一般检查</p>-->
          <div class="cheitem_box" style="padding: 10px 30px;color: #333;border-top: 1px solid #727070;overflow: hidden;">
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">身高（cm）：{{item.popupItem.height}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">身高评价：{{item.popupItem.heightComment}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">体重（kg）：{{item.popupItem.weight}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">体重评价：{{item.popupItem.weightComment}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">体重指数（%）：{{item.popupList.weightPercent}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">肥胖指数（%）：{{item.popupList.fatPercent}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">BMI：{{item.popupList.bmiValue}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">综合评价：{{item.popupList.overallComment}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">心肺：{{item.popupItem.lung}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">肝脾：{{item.popupItem.liver}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">皮肤：{{item.popupItem.skin}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">外生殖器：{{item.popupItem.wszq}}</span>
          </div>
          <!--<p class="checktype">眼科</p>-->
          <div class="cheitem_box" style="padding: 10px 30px;color: #333;border-top: 1px solid #727070;overflow: hidden;">
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">左眼视力：{{item.popupItem.LSight}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">左眼评价：{{item.LSight_Comment}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">右眼视力：{{item.popupItem.RSight}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">右眼评价：{{item.RSight_Comment}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">视力筛查：{{item.popupItem.SLSC}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">鼻：{{item.popupItem.NOSE}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">左耳：{{item.popupItem.LEar}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">右耳：{{item.popupItem.REar}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">牙齿数：{{item.popupItem.teethNum}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">龋齿数：{{item.popupItem.Caries}}</span>
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">血红蛋白：{{item.popupItem.HB}}</span>
          </div>
          <div class="cheitem_box" style="padding: 10px 30px;color: #333;border-top: 1px solid #727070;overflow: hidden;">
            <span style="width: calc(50% - 5px);display: inline-block;height: 30px;line-height: 30px;">其他：{{item.popupItem.qtfz}}</span>
          </div>
          <!--<p class="checktype">医生建议</p>-->
          <div class="cheitem_box" style="padding: 10px 30px;color: #333;border-top: 1px solid #727070;overflow: hidden;">
            <div style="width:100%;display:table;">
              <span style="line-height: 33px;float: left">检查结果：</span>
              <span style="margin-top: 5px;width: calc(100% - 80px);padding: 0;list-style: none;float: left;">{{item.popupList.checkResult}}</span>
            </div>
            <div style="width:100%;display:table;">
              <span style="line-height: 33px;float: left">医生意见：</span>
              <span style="margin-top: 5px;width: calc(100% - 80px);padding: 0;list-style: none;float: left;">{{item.popupList.doctorSuggestion}}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="padding-left: calc(50% - 60px);margin-top:30px;" v-if="row.length > 1">
        <el-button type="primary" size="small" class="but" @click="print()">立即打印</el-button>
        <el-button type="normal" size="small" class="but" @click="cancel()" style="margin:left:10px;">取消</el-button>
      </div>
    </div>
</template>
<script>
import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
export default {
  data () {
    return {
      row: [],
      itemList:[],
      loading:true,
    }
  },
  methods: {
    print () {
      let newWindow = window.open('_blank')   // 打开新窗口
      let codestr = document.getElementById('popup').innerHTML   // 获取需要生成pdf页面的div代码
      newWindow.document.write(codestr)   // 向文档写入HTML表达式或者JavaScript代码
      newWindow.document.close()     // 关闭document的输出流, 显示选定的数据
      newWindow.print()   // 打印当前窗口
      return true
    },
    cancel(){
      this.$emit('close');
    }
  },
  created () {
    let that = this;
    this.loading = true;
    this.row = this.$route.query.list;
    if(this.row.length > 0){
      let init = 0;
      this.row.forEach(child => {
        api.post(config.host + 'childMec/getChildMECDetailById.do', {'id': child.id}).then((json) => {
          let addItem  = {
            popupItem: [],
            popupList: json.body,
            LSight_Comment: '',
            RSight_Comment: ''
          }
          json.body.childMecItemList.forEach((i) => {
            addItem.popupItem[i.itemCode] = i.itemResult
            if (i.itemId === 1017) {
              addItem.LSight_Comment = i.itemComment
            }
            if (i.itemId === 1018) {
              addItem.RSight_Comment = i.itemComment
            }
          });
          that.itemList.push(addItem);
          init++;
          if(init == this.row.length){
            this.loading = false;
          }
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/physical/childPhyPrintBatch.vue